import { GRID_ROW_NUMBER_COL_DEF } from '@profgeosoft-ui/react';

export const CHECKBOX_SELECTION_COLUMN_FIELD = '__check__';
export const ACTIVITY_COLUMN_FIELD = 'activity';

export const SERVICE_COLUMNS = [GRID_ROW_NUMBER_COL_DEF.field, ACTIVITY_COLUMN_FIELD];
